import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQ() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: t('faq1Question'),
      answer: t('faq1Answer')
    },
    {
      question: t('faq2Question'),
      answer: t('faq2Answer')
    },
    {
      question: t('faq3Question'),
      answer: t('faq3Answer')
    },
    {
      question: t('faq4Question'),
      answer: t('faq4Answer')
    },
    {
      question: t('faq5Question'),
      answer: t('faq5Answer')
    },
    {
      question: t('faq6Question'),
      answer: t('faq6Answer')
    },
    {
      question: t('faq7Question'),
      answer: t('faq7Answer')
    },
    {
      question: t('faq8Question'),
      answer: t('faq8Answer')
    }
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': faqs.map((faq) => ({
      '@type': 'Question',
      'name': faq.question,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': faq.answer
      }
    }))
  };

  return (
    <section id="faq" className="py-24 bg-white" itemScope itemType="https://schema.org/FAQPage">
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-[rgb(0,0,139)]/10 rounded-full px-4 py-2 mb-4">
            <span className="text-[rgb(0,0,139)] text-sm font-semibold">{t('faqTag')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('faqTitle')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('faqDescription')}
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden border border-gray-200 hover:border-[rgb(0,0,139)] transition-colors"
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-100 transition-colors"
              >
                <span itemProp="name" className="text-lg font-semibold text-gray-900 pr-4">{faq.question}</span>
                <i className={`ri-arrow-down-s-line text-2xl text-[rgb(0,0,139)] transition-transform flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-5" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                  <p itemProp="text" className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center bg-gray-50 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-2">{t('stillQuestions')}</h3>
          <p className="text-gray-600 mb-6">{t('stillQuestionsDescription')}</p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-[rgb(0,0,139)] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[rgb(0,0,100)] transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('contactSupport')}
          </button>
        </div>
      </div>
    </section>
  );
}